<div class="games-running-modal-container h-100 d-flex flex-column" style="height: 350px;">
  <div class="modal-header">
    <h8 class="modal-title lato-bold" cvLocalizedText langSection="Games_Reward_Estimator" langKey="Estimate_Payout">
      Estimate Payout</h8>
    <button type="button" class="close" aria-label="Close" (click)="close()"><span
        aria-hidden="true">&times;</span></button>
  </div>

  <div class="modal-body flex-fill p-1">
    <div class="d-flex justify-content-between m-2">
      <div class="col-4 d-flex align-items-center">
        <div class="gameIconRewardContainer">
          <div class="gameIconReward {{gs.modified.item.definition.IconClass}}"></div>
        </div>
        <div class="pl-2 text-truncate">
          <span class="color-theUpsideDown font-size-16 lato-regular"
            ngbTooltip="{{gs.modified.item.underlyingRule.RuleName}}"
            placement="top">{{gs.modified.item.underlyingRule.RuleName}}</span>
        </div>
      </div>
      <div class="col-6 d-flex align-items-center">
        <div class="mr-2">
          <span cvLocalizedText langSection="Games_Reward_Estimator" langKey="Date_Range">Date Range: </span>
        </div>
        <div class="d-block">
          <cv-baremetrics-calendar *ngIf="dateRangePresets != null"
            class="d-block daterange daterange--double mb-1 reward-estimator-calendar" [(startDate)]="selectedStartDate"
            [(endDate)]="selectedEndDate" [(selectedPreset)]="selectedPreset" [presets]="dateRangePresets"
            (dateChanged)="loadGamesData($event)" [latestDate]="latestDate" [ngClass]="{'reLoading' : loadingData}">
          </cv-baremetrics-calendar>
        </div>
      </div>
      <div class="col-2 d-flex align-items-center hide">
        <button type="button" (click)="onExport()" [disabled]="loadingData" class="icon-btn fill-valyrianSteel">
          <svg class="icon-24" [ngClass]="{'fill-hover-cerulean' : !loadingData}">
            <use href="../App_Themes/clearview-default/icons/utility/export.svg#export"></use>
          </svg>
        </button>
      </div>
    </div>

    <div *ngIf="!isRaffle">
      <hr />
    </div>

    <div class="pt-2 d-flex raffle-component">
      <div *ngIf="isRaffle" class="raffle-info">
        <cv-raffle-rewards-details></cv-raffle-rewards-details>
        <div class="d-flex info-estimation">
          <span class="info-icon">
            <svg><use href="../App_Themes/clearview-default/icons/utility/info.svg#info"></use></svg>
          </span>
          <div class="info-body">
            <h4 class="info-tittle" cvLocalizedText langSection="Games_Reward_Estimator" langKey="Remember_title_raffle">Remember</h4>
            <p cvLocalizedText langSection="Games_Reward_Estimator" langKey="Estimation_text_raffle">This estimation will be based on previous data considering current game setup. Prize(s) will be given out to a random qualified participant</p>
          </div>
        </div>
      </div>
      <div class="reward-estimator-table">
        <cv-reward-estimator-table [isRaffle]="isRaffle" [participants]="gamesData"></cv-reward-estimator-table>
      </div>
    </div>

    <div class="color-fireball text-center font-size-14 lato-regular py-2" cvLocalizedText
      langSection="Games_Reward_Estimator" langKey="Estimation_Text" *ngIf="!isRaffle">
      This estimation will be based on previous data considering current game setup.
    </div>
  </div>
</div>